<template>
  <Problem :son="23" :questions="questions" />
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  props: [],
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.ct.two.one.ll_child.first.question',
          options: [
            {
              value: 'A',
              label: 'lang.ct.two.one.ll_child.first.options.A',
            },
            {
              value: 'B',
              label: 'lang.ct.two.one.ll_child.first.options.B',
            },
            {
              value: 'C',
              label: 'lang.ct.two.one.ll_child.first.options.C',
            },
            {
              value: 'D',
              label: 'lang.ct.two.one.ll_child.first.options.D',
            },
          ],
          answer: '',
          result: 'A',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.ct.two.one.ll_child.second.question',
          options: [
            {
              value: 'A',
              label: 'lang.ct.two.one.ll_child.second.options.A',
            },
            {
              value: 'B',
              label: 'lang.ct.two.one.ll_child.second.options.B',
            },
            {
              value: 'C',
              label: 'lang.ct.two.one.ll_child.second.options.C',
            },
            {
              value: 'D',
              label: 'lang.ct.two.one.ll_child.second.options.D',
            },
          ],
          answer: '',
          result: 'B',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>